import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid, Card, Box, Typography, FormControl, TextField, Button, FormControlLabel, Checkbox, Snackbar, Alert } from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const CreateCategoryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    publish: false,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' | 'error'
  });

  const [redirectOnClose, setRedirectOnClose] = useState(false);

  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
    if (redirectOnClose) {
      navigate("/categories");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(API_ENDPOINTS.CATEGORIES.CREATE, {
        name: formData.name,
        publish: formData.publish,
      });
      setSnackbar({
        open: true,
        message: "Category created successfully!",
        severity: "success",
      });
      setRedirectOnClose(true);
    } catch (error) {
      console.error("Error creating category:", error.response?.data || error.message);
      setSnackbar({
        open: true,
        message: "Error creating category: " + (error.response?.data?.message || "Something went wrong"),
        severity: "error",
      });
      setRedirectOnClose(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Add Category
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Category Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="publish"
                      checked={formData.publish}
                      onChange={handleChange}
                    />
                  }
                  label="Publish"
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button type="submit" variant="contained">
                Create Categories
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={1500}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateCategoryForm;